export default __webpack_public_path__ + "static/ups-3cdf7f3e311fc388cabbb067f5904e14.svg";